import { render, staticRenderFns } from "./LogoUploadComponent.vue?vue&type=template&id=0ef5c284&"
import script from "./LogoUploadComponent.vue?vue&type=script&lang=ts&"
export * from "./LogoUploadComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports